import React, {Component, createRef} from 'react';
import autobind from 'autobind-decorator';
import {Button} from 'react-bootstrap';

import {FileEditorEnhance, FileUploadOverlay} from "../../Files";
import {service as FileUploadService} from "../../../../Services/FileUploadService";

import {SurveyFormInputFileViewer} from "./SurveyFormInputFileViewer";
import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";
import {SurveyFormInputFileEnhance} from "./SurveyFormInputFileEnhance";
import {FileVisibilityHelper} from "../../Files/FileVisibilityHelper";

@SurveyFormInputEnhance
@SurveyFormInputFileEnhance
@FileEditorEnhance
export class SurveyFormInputFile extends Component {
    constructor(props) {
        super(props);

        this.inputField = createRef();

        this.state = {
            uploadProgress: 0,
            displayUpload: false,
        };
    }

    @autobind
    displayDialog() {
        const { inputField } = this;

        inputField?.current?.click?.();
    }

    @autobind
    onFileSelect(e) {
        const { files } = e?.target || {};

        if(files.length > 0)
        {
            this.processFile(files[0]);
        }
    }

    @autobind
    processFile(file) {
        const { ConservationAction, OnChange, SurveyFormInput } = this.props;

        this.setState({uploadProgress: 0, displayUpload: true}, _ => FileUploadService.UploadFile(
            file.name,
            file,
            [ConservationAction.contextNodeId],
            (a, b) => this.setState({uploadProgress: ((a / b) * 100)}),
            this.props.SurveyTypeId
        )
            .then(file =>
                this.setState(
                    {uploadProgress: 0, displayUpload: false},
                    _ => {
                        let answer = SurveyFormInput.GetAnswer();

                        if(answer) {
                            answer.fileUploadId = file.fileUploadId;

                            OnChange?.(answer);
                            this.props.FileEdit?.DisplayEditOverlay?.(file);
                        }
                    }
                )
            )
            .catch(_ => this.setState({uploadProgress: 0}))
        );
    }

    render() {
        const { EditMode, SurveyFormInput, SurveyFormInputFile } = this.props;
        const { displayUpload, uploadProgress, fileUpload } = this.state || {};

        const answer = SurveyFormInput.GetAnswer();
        let content = null;

        if(!EditMode) {
            return <span>
                <SurveyFormInputFileViewer Answer={answer} />
            </span>;
        }

        if(displayUpload) {
            content = <FileUploadOverlay UploadingFiles={1} FileProgress={uploadProgress} />;
        } else {
            let filename = null;

            if(answer && answer.fileUploadId) {
                filename = <a className="link-primary" onClick={_ => SurveyFormInputFile.DownloadFile(answer.fileUploadId)}>
                    {
                        SurveyFormInputFile.FileUpload ?
                            SurveyFormInputFile.FileUpload.name:
                            "N/A"
                    }
                </a>;
            }

            content = <React.Fragment>
                <span className="filename">
                    {filename ?? "Select A File"}
                    <FileVisibilityHelper file={SurveyFormInputFile?.FileUpload} />
                </span>
                <Button
                    className="pndlm-image-upload-button pndlm-button-grey"
                    onClick={this.displayDialog}
                >
                    {filename ? "Replace" : "Upload"}
                </Button>

                <input
                    style={{display: "none"}}
                    ref={this.inputField}
                    type="file"
                    onChange={this.onFileSelect}
                    multiple={false}
                />
            </React.Fragment>;
        }

        return <div className="sb-survey-form-input-file">{content}</div>;
    }
}


